module.exports = __webpack_public_path__ + "img/sb06.1a127b72.png";